import styles from "../common/Page.module.css";
import PhotoBoard from "Page/common/PhotoBoard";

export default function Outsourcing() {
  return (
    <div className={styles.Content}>
      <PhotoBoard
        title={"외주 현황"}
        api="portfolio"
        to="portfolio/outsourcing"
        category_id="9"
      />
    </div>
  );
}
